export default __webpack_public_path__ + "static/media/detail_Image.0fc51abc.png";